import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {RiverBreakoutSchema} from './riverBreakout'
import {IconAssetLinkItemSchema} from './iconAssetLinkItem'
import {ImageLinkItemSchema} from './imageLinkItem'
import {LabelAssetLinkItemSchema} from './labelAssetLinkItem'
import {LinkSchema} from './link'

export const RiverVariantEnum = z.enum(['Accordion', 'Stack'])
export const BreakoutVariantEnum = z.enum(['Breakout', 'Carousel'])
export const CardsVariantEnum = z.enum(['Footsteps', 'Large Cards'])

export const DetailSectionSchema = buildEntrySchemaFor('detailSection', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      sectionIntroHeading: RichTextSchema,
      sectionIntroLabel: safeOptional(z.string()),
      sectionIntroDescription: safeOptional(RichTextSchema),
      sectionIntroLink: safeOptional(LinkSchema),
      riverVariant: safeOptional(RiverVariantEnum),
      featureRiverAccordion: safeOptional(z.array(IconAssetLinkItemSchema)),
      featureRiverStack: safeOptional(z.array(LabelAssetLinkItemSchema)),
      breakoutVariant: safeOptional(BreakoutVariantEnum),
      featureRiverBreakout: safeOptional(RiverBreakoutSchema),
      featureBreakoutTabs: safeOptional(z.array(IconAssetLinkItemSchema)),
      cardsVariant: safeOptional(CardsVariantEnum),
      featureFootstepsLabel: safeOptional(z.string()),
      featureFootstepsHeading: safeOptional(RichTextSchema),
      featureFootstepsLink: safeOptional(LinkSchema),
      featureFootstepsCards: safeOptional(z.array(ImageLinkItemSchema)),
      featureLargeCardsHeading: safeOptional(RichTextSchema),
      featureLargeCards: safeOptional(z.array(ImageLinkItemSchema)),
      videoPlaylistHeading: safeOptional(RichTextSchema),
      videoPlaylistItems: safeOptional(z.array(IconAssetLinkItemSchema)),
    }),
  ),
})
export type DetailSection = z.infer<typeof DetailSectionSchema>
